/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import deliveryOrder from '../action/deliveryOrderActions'

export const initialState = ({
  isLoading: false,
  deliveryOrders: null,
  status: null,
})

export default function (state = initialState, action) {
  switch (action.type) {

    case deliveryOrder.TYPES.REQUEST_DELIVERY_ORDER: return Object.assign({}, state, { isLoading: true, deliveryOrders: null, status: null })

    case deliveryOrder.TYPES.REQUEST_DELIVERY_ORDER_SUCCESS:
      return Object.assign({}, state, {
        deliveryOrders: action.payload,
        isLoading: false,
      });

    case deliveryOrder.TYPES.REQUEST_DELIVERY_ORDER_FAILED:
      return Object.assign({}, state, { deliveryOrders: null, isLoading: false, status: { status: 400, message: "Failed" } })

    case deliveryOrder.TYPES.UPDATE_ORDER_LIST:
      return Object.assign({}, state, { deliveryOrders: action.payload, isLoading: false, status: null})

    default:
      return state
  }
}
